// import React from 'react';

import { aiConfigItemMessages } from '@atlaskit/editor-common/ai-messages';
import type { EditorAgent } from '@atlassian/generative-ai-modal/utils/agents';

import type { EditorPluginAIProvider } from '../../../types/types';
import { createInsertAtCurrentPosition, createReplace } from './actions/create-actions';
import { createContinueInChatForAgent } from './actions/create-continue-in-chat';
import { CONFIG_ITEM_KEYS } from './config-item-keys';
import type { EditorPluginAIConfigItem } from './config-items';

export const createAgentConfigItem = (
	agent: EditorAgent,
	editorPluginAIProvider: EditorPluginAIProvider,
): EditorPluginAIConfigItem => {
	const continueInChat = createContinueInChatForAgent({
		appearance: 'secondary',
		agent,
		product: editorPluginAIProvider.product,
		actionSideEffect: editorPluginAIProvider.actionSideEffects?.['continueInChat'],
		actionOverride: editorPluginAIProvider.actionOverrides?.['continueInChat'],
		factoryOptions: {
			product: editorPluginAIProvider.product,
			isInDocumentStreamingEnabled: editorPluginAIProvider.isInDocumentStreamingEnabled,
		},
	});

	return {
		key: CONFIG_ITEM_KEYS.ROVO_AGENT,
		title: aiConfigItemMessages.agentConfigTitle,
		description: aiConfigItemMessages.agentConfigDescription,
		statusLozengeType: 'beta',
		promptHint: aiConfigItemMessages.agentConfigPromptHint,
		// Required, since hasInitialPreset guard in palette state machine
		// checks this property for whether to transition to 'preset label'
		// (agent palette mode) during initialisation.
		promptLabel: {
			defaultMessage: agent?.name,
			// Ignored via go/ees005
			// eslint-disable-next-line require-unicode-regexp
			id: `fabric.editor.ai.config.item.range.agent.${agent?.name.toLocaleLowerCase().replace(/\s+/g, '.') || 'label'}`,
		},
		disableInterrogation: () => false,
		agent,
		intentSchemaId: 'DISABLED',
		getBackendModel: () => 'assistance-service',
		actions: {
			empty: [
				continueInChat,
				createInsertAtCurrentPosition({ appearance: 'primary', isRovoAgentAction: true }),
			],
			selection: [
				continueInChat,
				createReplace({ appearance: 'primary', isRovoAgentAction: true }),
			],
		},
	};
};
